<template>
  <b-sidebar
    id="complaint-summary-sidebar"
    v-model="localVisible"
    title="Resumo da Denúncia"
    width="50%"
    right
    shadow
    backdrop
    @hidden="onHidden"
  >
    <template #title>
      <div class="d-flex align-items-center w-100">
        <b-badge
          v-if="complaint"
          :variant="getBadgeColor(complaint.status)"
          class="mr-4"
        >
          {{ getStatusText(complaint.status) }}
        </b-badge>
        <span>Resumo da Denúncia</span>
      </div>
    </template>
    <complaint-summary
      v-if="complaint"
      :complaint="complaint"
      :events="events"
      @close="emitClose"
    />
  </b-sidebar>
</template>

<script>
import ComplaintSummary from "../ComplaintSummary.vue";

export default {
  name: "SummarySidebar",
  components: { ComplaintSummary },
  props: {
    visible: { type: Boolean, default: false },
    complaint: { type: Object, default: null },
    events: { type: Array, default: () => [] },
  },
  data() {
    return {
      localVisible: this.visible,
    };
  },
  watch: {
    visible(newVal) {
      this.localVisible = newVal;
    },
    localVisible(newVal) {
      this.$emit("update:visible", newVal);
    },
  },
  methods: {
    onHidden() {
      this.emitClose();
    },
    emitClose() {
      this.$emit("close");
    },
    getStatusText(status) {
      switch (parseInt(status)) {
        case 0:
          return "Nova";
        case 1:
          return "Em processamento";
        case 2:
          return "Concluída";
        case 3:
          return "Encerrada";
        default:
          return "Indefinido";
      }
    },
    getBadgeColor(status) {
      switch (parseInt(status)) {
        case 0:
          return "primary";
        case 1:
          return "warning";
        case 2:
          return "success";
        case 3:
          return "dark";
        default:
          return "secondary";
      }
    },
  },
};
</script>

<style scoped></style>
